import ability from './ability'

export const canNavigate = to => {

  return to.matched.some(route => {

    let permissions = route?.meta?.permissions

    if (permissions) {
      return ability.can('all', permissions);
    }

    return true
  })
}

export const _ = undefined
